export default __webpack_public_path__ + "static/media/times_new_roman.f85717da.ttf";